import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Grid,
  Typography
} from '@material-ui/core';

class BookingFormInlineItemRowInfo extends Component {
  render() {
    const {
      label,
      items
    } = this.props;

    return (
      <>
        <Grid item xs={3} className="bookingFormLabel">
          <Typography component="div">
            <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
              {label}
            </Box>
          </Typography>
        </Grid>
        {items.length < 4
          ?
            items.map(item =>
              <Grid key={item.label} item xs={3} className="bookingFormLabel">
                <p className="bookingStaticField">
                  {`${item.value} ${item.label}`}
                </p>
              </Grid>
            )
          : (
            <Grid item xs={9} className="bookingFormLabel">
              <p className="bookingStaticField">
                {items.map(item => `${item.value} ${item.label} `)}
              </p>
            </Grid>
          )
        }
      </>
    )
  }
}

BookingFormInlineItemRowInfo.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape([PropTypes.string, PropTypes.number])).isRequired,
}

export default BookingFormInlineItemRowInfo;
